<template>
    <div class="max-width-content">
        <trashed-message v-if="jobtemplate.deleted_at" class="mb-6" @restore="restore">
            This jobtemplate has been deleted.
        </trashed-message>

        <breadcrumbs>
            <inertia-link :href="route('admin.jobtemplates.index')">Blog</inertia-link>
            <i class="fad fa-chevron-right"></i>
            <inertia-link :href="route('admin.jobtemplates.show', jobtemplate.id)">{{ jobtemplate.title | truncate(35) }}</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Wijzig
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <job-template-form :jobtemplate="jobtemplate" @submit="submit" :data-loading="loading"></job-template-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import JobTemplateForm from "@/admin/Pages/JobTemplates/JobTemplateForm";

export default {
    metaInfo() {
        return { title: this.jobtemplate.title };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        TrashedMessage,
        Breadcrumbs,
        JobTemplateForm
    },

    mixins: [Helpers],

    props: {
        jobtemplate: Object,
    },

    data() {
        return {};
    },

    methods: {
        submit(data) {
            this.loading = "submit";

            const url = this.route("admin.jobtemplates.update", this.jobtemplate.id).url();
            data.append("_method", "patch");

            const options = { onFinish: () => this.loading = false};

            this.$inertia.post(url, data, options);
        },

        restore() {
            this.loading = "restore";
            if (confirm("Are you sure you want to restore this jobtemplate?")) {
                const url = this.route("admin.jobtemplates.restore", this.jobtemplate.id)
                const options = { onFinish: () => this.loading = false};

                this.$inertia.patch(url, options)
            }
        }
    }
};
</script>
